import React from "react";
import "./Footer.css";
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import PinterestIcon from '@material-ui/icons/Pinterest';
import HomeIcon from '@material-ui/icons/Home';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

function Footer() {
	return (
		<div className="footer">
			<div className="footer__aboutRestuarant">
				<div className="footer__titles"> About Restuarant </div>
				<p className="footer__aboutRestuarantP">
					Hello everyone, we warmly welcome you all to the 5-Star Restaurant! Here at 5 Star Restaurant, we are continually trying to improve our service and quality in order to give our customers the very best different culture food experience. Our online ordering website! So that our customers can relax at home and order their favourite, freshly cooked meals from 5-Star Restaurant in Devon Park	
				</p>
				<div className="footer__restuarantOwnerName"> -Shamima Ali. Owner </div>
			</div>
			<div className="footer__contactDetails1">
				<div className="footer__titles"> Keep connected </div>
				<div className="footer__contactDetails1Icons">
					<div>
						<FacebookIcon style={{color: "rgb(59, 89, 162)", fontSize: "30px", margin: "0px 10px 0px 0px"}}/>
						<div> Like us on Facebook </div>
					</div>
					<div>
						<TwitterIcon style={{color: "rgb(28, 162, 222)", fontSize: "30px", margin: "0px 10px 0px 0px"}}/>
						<div> Follow us on Twitter </div>
					</div>
					<div>
						<InstagramIcon style={{color: "rgb(221, 42, 123)", fontSize: "30px", margin: "0px 10px 0px 0px"}}/>
						<div> Follow us on Instagram </div>
					</div>
					<div>
						<PinterestIcon style={{color: "rgb(189, 8, 28)", fontSize: "30px", margin: "0px 10px 0px 0px"}}/>
						<div> Follow us on Pinterest </div>
					</div>
				</div>
			</div>

			<div className="footer__contactDetails2">
				<div className="footer__titles"> Contact Information </div>
				<div className="footer__contactDetails2Icons">
					<div>
						<HomeIcon style={{color: "", fontSize: "30px", margin: "0px 10px 0px 0px"}}/>
						<div> 38 Alexander Ave, Devon ParK SA 5008 </div>
					</div>
					<div>
						<PhoneIcon style={{color: "", fontSize: "30px", margin: "0px 10px 0px 0px"}}/>
						<div> +61 032 004 8339 </div>
					</div>
					<div>
						<EmailIcon style={{color: "", fontSize: "30px", margin: "0px 10px 0px 0px"}}/>
						<div> ASO5S@gmail.com </div>
					</div>
				</div>
			</div>
			<Link to="feedback" className="footer__sendFeedBackButtonContainer">
			<Button variant="" color="" className="footer__sendFeedBackButton"> Send Feedback </Button>
			</Link>
		</div>
	)
}

export default Footer;